export function formatDate(date) {
  if(date) {
    return date.split("T")[0];
  }
  return "";
}

export function formatTime(dateISOString){
     return dateISOString.split("T")[1].split("Z")[0];
}
